import ABCyaPhaser from "@abcya/abcya_phaser";
import AScene from "../../library/ExtendedObjects/AScene.js";
import TweensClass from "../TweensFolder/TweensIntro.js";
import UIAssetKeys from "../../UIAssetKeys.js";
import ABCyaLib from "@abcya/abcya_lib";
import FontKeys from "../../FontKeys.js";

export default class Intro extends AScene
{
    static get KEY() { return 'Intro'; }

    create()
    {
        var i = 0;
        this.count = 0;
        this.Strings = [];

        //this.sound.mute = true;
        
        this.Jingle = this.playSound("jingle_MaC",1,true);

        this.DepthListIntro = 
        {
            Background:0,
            PurpleBalloonBack: 0,
            PurpleBalloonTop: 0,
            Table: 0,
            Playstring: 0,
            Flames:0, //Play Balloon, Cake
            MakeText: 0, // Play Button
            Letters: 0,
        }
        //Rope Hex colors
        //Dark Purple: ac2ae4
        //Dark Pink: e640e7
        //Orange: e2720e

        for (let x in this.DepthListIntro)
        {
            this.DepthListIntro[x] = i;
            i++;
        }

        this.Animations = new TweensClass(this);
        this.PlaceAssets();
    }

    PlaceAssets()
    {
        var CakeLetters = [];
        var Balloons = []; 
        var Flame = [];
        var PlayBalloon = [];
        var Back = this.addImage(0,0,"Bckg_1");
        Back.setOrigin(0,0);

        var Table = this.addImage(0,768,"Title Screen/Background");
        Table.setOrigin(0,1);
        Table.setDepth(this.DepthListIntro.Table);

        const Cake = this.add.container();
        var Cake1 = ABCyaPhaser.Images.addImage(437, 511, UIAssetKeys._Title_Screen_Title_Cake, this);
        Cake.add(Cake1);
        Cake.setDepth(this.DepthListIntro.Flames);

        const CakeText = this.add.container().setDepth(this.DepthListIntro.MakeText).setAlpha(0);
        const CakeSymbol = [];

        if (ABCyaLib.Environment.instance.locale !== 'es-US') {
          CakeSymbol.push(ABCyaPhaser.Text.addText(214, 94, 112, 0xff8622, FontKeys._snigletregular, 'M', this).setDepth(40).setOrigin(0.5, 0));
          CakeSymbol.push(ABCyaPhaser.Text.addText(301, 104, 112, 0xff8622, FontKeys._snigletregular, 'A', this).setDepth(40).setOrigin(0.5, 0));
          CakeSymbol.push(ABCyaPhaser.Text.addText(390, 111, 112, 0xff8622, FontKeys._snigletregular, 'K', this).setDepth(40).setOrigin(0.5, 0));
          CakeSymbol.push(ABCyaPhaser.Text.addText(481, 111, 112, 0xff8622, FontKeys._snigletregular, 'E', this).setDepth(40).setOrigin(0.5, 0));
          CakeSymbol.push(ABCyaPhaser.Text.addText(655, 96, 112, 0xff8622, FontKeys._snigletregular, 'A', this).setDepth(40).setOrigin(0.5, 0));

          CakeSymbol.forEach((cakeSymbol)=>{
            cakeSymbol.setStroke('#ffcc39', 15);
            const tempFlame = ABCyaPhaser.Images.addImage(cakeSymbol.x, cakeSymbol.y + 42, UIAssetKeys._Title_Screen_Flame, this);
            Flame.push(tempFlame);
            tempFlame.setDepth(this.DepthListIntro.Flames);
            const candlePosistion = tempFlame.getBottomCenter();
            CakeText.add(cakeSymbol);

            const tempCandle = ABCyaPhaser.Images.addImage(candlePosistion.x, candlePosistion.y + 8, UIAssetKeys._Title_Screen_Title_Candle, Cake).setOrigin(0.5, 0.10);
          })

          CakeLetters[0] = ABCyaPhaser.Text.addText(268, 512, 192, 0xffc7e2, FontKeys._snigletregular, 'C', this).setDepth(this.DepthListIntro.Letters).setAngle(4);
          CakeLetters[1] = ABCyaPhaser.Text.addText(389, 523, 192, 0xffc7e2, FontKeys._snigletregular, 'A', this).setDepth(this.DepthListIntro.Letters).setAngle(4);
          CakeLetters[2] = ABCyaPhaser.Text.addText(510, 521, 192, 0xffc7e2, FontKeys._snigletregular, 'K', this).setDepth(this.DepthListIntro.Letters).setAngle(-2);
          CakeLetters[3] = ABCyaPhaser.Text.addText(629, 514, 192, 0xffc7e2, FontKeys._snigletregular, 'E', this).setDepth(this.DepthListIntro.Letters).setAngle(-8);


          for (let x in CakeLetters)
          {
              CakeLetters[x].setAlpha(0);
              CakeLetters[x].setShadow(6,4, '#ed436c', 0, true, true);
          }
      }
      else {
        CakeSymbol.push(ABCyaPhaser.Text.addText(211, 86, 126, 0xff8622, FontKeys._snigletregular, 'H', this).setDepth(40).setOrigin(0.5, 0));
        CakeSymbol.push(ABCyaPhaser.Text.addText(302, 96, 126, 0xff8622, FontKeys._snigletregular, 'A', this).setDepth(40).setOrigin(0.5, 0));
        CakeSymbol.push(ABCyaPhaser.Text.addText(391, 103, 126, 0xff8622, FontKeys._snigletregular, 'Z', this).setDepth(40).setOrigin(0.5, 0));
        CakeSymbol.push(ABCyaPhaser.Text.addText(542, 103, 126, 0xff8622, FontKeys._snigletregular, 'U',   this).setDepth(40).setOrigin(0.5, 0));
        CakeSymbol.push(ABCyaPhaser.Text.addText(649, 90, 126, 0xff8622, FontKeys._snigletregular, 'N', this).setDepth(40).setOrigin(0.5, 0));

        CakeSymbol.forEach((cakeSymbol, index)=>{
          cakeSymbol.setStroke('#ffcc39', 15);
          const tempFlame = ABCyaPhaser.Images.addImage(cakeSymbol.x, cakeSymbol.y + 50, UIAssetKeys._Title_Screen_Flame, this);
          if (index === 0) {
            cakeSymbol.x -= 3;
          }
          else if (index === 3) {
            cakeSymbol.y += 8;
          }
          Flame.push(tempFlame);
          tempFlame.setDepth(this.DepthListIntro.Flames);
          const candlePosistion = tempFlame.getBottomCenter();
          CakeText.add(cakeSymbol);

          const tempCandle = ABCyaPhaser.Images.addImage(candlePosistion.x, candlePosistion.y, UIAssetKeys._Title_Screen_Title_Candle, Cake).setOrigin(0.5, 0.10);
        })

        CakeLetters[0] = ABCyaPhaser.Text.addText(252, 494, 146, 0xffc7e2, FontKeys._snigletregular, 'P', this).setDepth(this.DepthListIntro.Letters).setAngle(8);
        CakeLetters[1] = ABCyaPhaser.Text.addText(331, 507, 146, 0xffc7e2, FontKeys._snigletregular, 'A', this).setDepth(this.DepthListIntro.Letters).setAngle(2);
        CakeLetters[2] = ABCyaPhaser.Text.addText(417, 509, 146, 0xffc7e2, FontKeys._snigletregular, 'S', this).setDepth(this.DepthListIntro.Letters);
        CakeLetters[3] = ABCyaPhaser.Text.addText(502, 509, 146, 0xffc7e2, FontKeys._snigletregular, 'T', this).setDepth(this.DepthListIntro.Letters).setAngle(-2);
        CakeLetters[4] = ABCyaPhaser.Text.addText(583, 506, 146, 0xffc7e2, FontKeys._snigletregular, 'E', this).setDepth(this.DepthListIntro.Letters).setAngle(-4);
        CakeLetters[5] = ABCyaPhaser.Text.addText(661, 498, 146, 0xffc7e2, FontKeys._snigletregular, 'L', this).setDepth(this.DepthListIntro.Letters).setAngle(-8);

        for (let x in CakeLetters)
        {
            CakeLetters[x].setAlpha(0);
            CakeLetters[x].setShadow(6,4, '#ed436c', 0, true, true);
        }
      }

        Balloons[0] = this.addImage(-40, 170, "Title Screen/Blln_2").setDepth(this.DepthListIntro.PurpleBalloonTop);
        Balloons[1] = this.addImage(49, 142, "Title Screen/Blln_3").setDepth(this.DepthListIntro.PurpleBalloonBack);
        Balloons[2] = this.addImage(115, 216, "Title Screen/Blln_4").setDepth(this.DepthListIntro.PurpleBalloonTop);
        Balloons[3] = this.addImage(778, 199, "Title Screen/Blln_1").setDepth(this.DepthListIntro.PurpleBalloonBack);
        Balloons[4] = this.addImage(864, 164, "Title Screen/Blln_2").setDepth(this.DepthListIntro.PurpleBalloonTop);
        Balloons[5] = this.addImage(944, 148, "Title Screen/Blln_3").setDepth(this.DepthListIntro.PurpleBalloonBack);
        Balloons[6] = this.addImage(978, 226, "Title Screen/Blln_4").setDepth(this.DepthListIntro.PurpleBalloonTop);

        this.Strings[0] = this.add.rope(Balloons[1].x+10,Balloons[1].y + 85, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xac2ae4);
        this.Strings[1] = this.add.rope(Balloons[2].x-15,Balloons[2].y + 85, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xe640e7);
        this.Strings[2] = this.add.rope(Balloons[3].x+15,Balloons[3].y + 85, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xac2ae4);
        this.Strings[3] = this.add.rope(Balloons[4].x+11,Balloons[4].y + 85, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xe640e7);
        this.Strings[4] = this.add.rope(Balloons[5].x-15,Balloons[5].y + 85, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xac2ae4);
        this.Strings[5] = this.add.rope(Balloons[6].x-15,Balloons[6].y + 85, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xe640e7);        

        this.Animations.BalloonsRise(Balloons, this.Strings);

        PlayBalloon[0] = this.addImage(897, 255, "Title Screen/PlayBlln").setDepth(this.DepthListIntro.Flames);
        this.Strings[6] = this.add.rope(PlayBalloon[0].x+5, PlayBalloon[0].y + 200, 'UIAssets', "Title Screen/Balloon_String_Purple",24,false).setColors(0xe2720e);
        this.Strings[6].setDepth(this.DepthListIntro.Playstring);
        this.Strings[6].setVisible(false);
        PlayBalloon[0].setVisible(false);

        PlayBalloon[1] = this.Strings[6];

        // PlayBalloon.on('pointerdown',()=>
        // {
        //     //this.scene.start("PickCakeColor");
        // });

        var PlayButton = this.addButton(907,255,"Title Screen/PlayBtn",null,()=>
        {
            //this.scene.start("PickCakeColor");
            for (let x = 0; x < 11; x++)
            {
                this.addDelay(80 * x,()=>{this.Jingle.volume = (1 - (.1 * x));});
            }
            Balloons[7] = PlayBalloon[0];
            this.Animations.ToColorBalloons(Balloons,this.Strings, PlayButton)
            this.Animations.ToColorCake(Flame, CakeText, CakeLetters, Cake,Table);
        }).setDepth(this.DepthListIntro.MakeText);

        PlayButton.soundKey = "button_menu_click";

        PlayBalloon[2] = PlayButton;

        PlayButton.setOrigin(.5,.5);
        PlayButton.setVisible(false);

        this.Animations.FireRise(Flame, CakeText, CakeLetters, PlayBalloon); 
    }

    update()
    {
        if (this.Strings.length > 0)
        {

            let points = [];
            let Delay = [.4,.34,.3,.27,.36,.38,.28,.29];
            points[0] = this.Strings[0].points;
            points[1] = this.Strings[1].points;
            points[2] = this.Strings[2].points;
            points[3] = this.Strings[3].points;
            points[4] = this.Strings[4].points;
            points[5] = this.Strings[5].points;
            points[6] = this.Strings[6].points;

            this.count += .1;

            for (let loop = 0; loop < 7; loop++)
            {

                for (let i = 9; i < points[loop].length; i++)
                {
                    points[loop][i].x = Math.sin(i * Delay[loop] - this.count); //+ (Direction[loop]*points[loop][i].x);
                }
                
                this.Strings[loop].setDirty();
            }
        }
    }
}